module.exports = __webpack_public_path__ + "img/LUB00402.bc937345.png";